import {
  writable,
  readable,
  derived,
} from "svelte-persistent-store/dist/session";

export const user = writable("user", { loggedIn: false });
